import React from 'react';
import {useEffect} from 'react'
import Drawer from '@material-ui/core/Drawer';
import TabellaAttributi from './TabellaAttributi'
import './VisualizzaAttributi.css'
import { connect } from 'react-redux';
function VisualizzaAttributi (props){
    
    const [open, setOpen] = React.useState(false);

      useEffect(()=>{
        
        if (props.attributi.state === true){
          setOpen(true)
        }else{
          setOpen(false)
        }
      },[props.attributi])


      // const handleDrawerClose = () => {
      //     // setOpen(false);
      
      
      // };

    return (
        <div>
        <Drawer
                transitionDuration={500}
                className={"drawerAttributi"}
                variant="persistent"
                anchor="bottom"
                open={open}
                classes={{
                    paper: "drawerPaperAttributi",
                    }}
            >       
            {/* <TabellaAttributi/> */}
            </Drawer>
      </div>
        )
}
const mapStateToProps = state => {
    return {
        attributi: state.attributi.attributi
    }
  }
export default connect(mapStateToProps) (VisualizzaAttributi);